import React, { useState, useEffect } from 'react';
import ToastService from '../../../services/ToastService';
import MasterService from '../../../services/MasterService';
import SchemeService from '../../../services/SchemeService';
import { showLoading } from 'react-global-loading';

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

const AddSchemes = ({ dismissModal, location }) => {
  const [schemeTitle, setSchemeTitle] = useState('');
  const [schemeDesc, setSchemeDesc] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [schemeApi, setSchemeApi] = useState(null);
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  useEffect(() => {
    getCategories();
    getAllCountries();
  }, []);

  const getAllCountries = async () => {
    try {
      const result = await MasterService.getAyushCountries();
      if (!result) return;
      setCountries(result);
    } catch (err) {
      console.error(err);
    }
  };

  const getCategories = async () => {
    try {
      const result = await MasterService.getCategories();
      if (!result) return;
      setCategories(result);
    } catch (err) {
      console.error(err);
    }
  };

  const deleteScheme = () => {
    setSchemeApi(null);
  };

  const handleCategories = (status, catId) => {
    if (status) {
      setSelectedCategory([...selectedCategory, catId]);
    } else {
      setSelectedCategory(selectedCategory.filter((item) => item !== catId));
    }
  };

  const onSchemeSelection = (event) => {
    setSchemeApi(event.target.files[0]);
  };

  const onSchemeCreation = async () => {
    if (
      (selectedCountry || userData.blog_id?.userblog_id) &&
      schemeTitle &&
      schemeApi &&
      selectedCategory.length > 0
    ) {
      const data = new FormData();
      data.append('post_title', schemeTitle);
      data.append('post_content', schemeDesc);
      data.append('document_upload', schemeApi);
      data.append('category', selectedCategory);
      data.append("lang", localStorage.getItem('localLang'));
      userData.roles === "administrator" ? data.append('blog_id', selectedCountry) : data.append('blog_id', userData.blog_id?.userblog_id);

      try {
        showLoading(true);
        if (location?.state?.editData) {
          const result = await SchemeService.updateScheme(data);
          if (result.data === 200) {
            ToastService.success(result.data.message);
            dismissModal();
          } else {
            ToastService.error(result.data.message);
          }
        } else {
          const result = await SchemeService.createScheme(data);
          if (result.data === 200) {
            ToastService.success(result.data.message);
            dismissModal();
          } else {
            ToastService.error(result.data.message);
            window.history.back();
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        showLoading(false);
      }
    } else {
      ToastService.error("Please fill required details");
    }
  };

  return (
    <>
      <div className="container-fluid productscontainer" id="main">
        {/* Removed commented out breadcrumb section */}
        <div className="row mt-3">
          <div className="col-12">
            <div className="row mt-4 contrast-ration-sol">
              <div className="col-md-10">
                <div className="head-title">
                  <h4 className="t0">Add Scheme</h4>
                </div>
              </div>
              <div className="col-md-2 text-end btr">
                <button onClick={onSchemeCreation} type="button" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn">Save Scheme</button>
              </div>
            </div>
            <div className="row box-main mt-4 mb-3 bg-white">
              <div className="col-md-6 mt-2">
                {/* <ul className="nav d-flex" id="pills-tab">
                  <li className="nav-item active">
                    <div className="d-flex align-items-center"><i className="fa fa-folder-open-o" aria-hidden="true"></i> <span className="ms-2">Internal</span></div>
                    <div><a href="#">...</a></div>
                  </li>
                  ... other nav items
                </ul> */}
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="documenttitle" id="schemetitle" className="form-label over-label t3">Scheme Title *</label>
                  <input aria-labelledby="schemetitle" type="text" className="form-control" name="documenttitle" value={schemeTitle}
                    onChange={(e) => setSchemeTitle(e.target.value)} />
                </div>
                {
                  userData.roles === "administrator" ? <div className="form-group mb-4 position-relative">
                    <select name='orderby' className='form-control' aria-label='Shop order' value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}>
                      <option defaultValue='selected'>Countries*</option>
                      {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
                    </select>
                  </div> : ''}
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="documentdescription" id="schemedetails" className="form-label over-label t3">Scheme Description </label>
                  <textarea aria-labelledby="schemedetails" className="form-control" rows="3" value={schemeDesc}
                    onChange={(e) => setSchemeDesc(e.target.value)}></textarea>
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="eventname" className="form-label t2"><b>Select Domain*:</b></label>
                  <div className="btn-group d-block event-check" role="group" aria-label="Basic checkbox toggle button group">
                    {categories.map((item, index) => <span key={index}> <input type="checkbox" className="btn-check" id={index} autoComplete="off" onClick={(e) => handleCategories(e.target.checked, item.name)} />
                      <label className="btn btn-outline-dark " htmlFor={index}>{item.name}</label></span>)}
                  </div>
                </div>
              </div>
              <div className="col-md-6 tab-content d-flex mt-2 pdtb15" id="pills-tabContent">
                <div className="d-flex align-items-center">
                  {schemeApi ?
                    <> <img src={require('../../../public/pdf_view-all.png')} className="img-fluid" alt="pdf file" />
                      <span>{schemeApi.name}</span>
                    </> :
                    <> <i className="fa fa-plus fs-3 text-secondary adddocs" aria-hidden="true"></i>
                      <p className="tab-para">Drop your Files Here</p>
                      <input aria-labelledby="schemeupload" id="schemeupload" type="file" name="file" accept="application/pdf" onChange={onSchemeSelection} />
                      <small className="text-muted pt-3">Upload Scheme in pdf format</small>
                    </>

                  }

                  {schemeApi && <div className="d-block del-btn">
                    <button onClick={deleteScheme}><i className="fa fa-trash" aria-hidden="true"></i></button>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSchemes;